import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Icon } from "../../Icons/check-icon.svg";
import data from "../../json/landingpage/BusinessTarget.json";
import parse from "html-react-parser";
export const BusinessTarget = () => {
  return (
    <div className="w-screen py-20  business">
      <div className="2xl:container m-auto flex flex-col md:px-10 lg:px-20  gap-12 sm:gap-16 px-6">
        <div className="flex w-full flex-col items-center gap-3 sm:gap-4">
          <h3 className="font-miniheading text-orangeyellow text font-semibold text-16 md:text-18 lg:text-20">
            {data.Title}
          </h3>
          <h2 className="text-primarycolor font-semibold lg:text-48 text-center w-full xl:w-[80%]  text-20 min-[450px]:text-24 md:text-36">
            {parse(data.Heading)}
          </h2>
          <p className="text-16 md:text-18   text-center w-[90%] xl:w-[70%]  text-regular text-secondaryblack">
            {data.para}
          </p>
        </div>
        <div className="flex flex-col items-center lg:items-start lg:flex-row gap-6 sm:gap-8">
          {data.cards.map((item, i) => (
            <div
              key={i}
              className="flex lg:w-[70%] flex-col w-full  lg:h-fit text-left lg:w-1/3 gap-5 p-6 bg-white rounded-[24px] border-journeyborder border-[1px] shadow-services"
            >
              <h2 className="text-primarycolor text-20 md:text-24 font-semibold ">
                {item.title}
              </h2>
              <div className="flex items-start gap-4 text-secondaryblack">
                <div className="w-[25px] h-[25px]">
                  <Icon />
                </div>{" "}
                <p className="sm:text-16 text-14">{item.para1}</p>
              </div>
              <div className="flex items-start gap-4 text-secondaryblack ">
                <div className="w-[25px] h-[25px]">
                  <Icon />
                </div>{" "}
                <p className="sm:text-16 text-14">{item.para2}</p>
              </div>
              <div className="flex items-star gap-4 text-secondaryblack">
                <div className="w-[25px] h-[25px]">
                  <Icon />
                </div>{" "}
                <p className="sm:text-16 text-14">{item.para3}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
